import React, { Component } from "react";
import { Table, Button, Accordion } from "semantic-ui-react";
import _, { get } from "lodash";
import PersonMetaData from "../../metadata/PersonMetadata";
import Phone from "./Phone";
import Counties from "./Counties";
import CaseComponent from "../common/CaseComponent";
import getSsn from "../common/Ssn";
import SSNRiskReport from "../reports/Platinum/SSNRiskReport";
import { getDodDate } from "../common/DisplayDate";

class PersonDetail extends Component {
  componentDidMount() {}

  render() {
    const results = [];
    const names = [];
    let personResult;
    if (
      this.props.reportData !== undefined &&
      this.props.reportData !== null &&
      this.props.reportData !== ""
    ) {
      personResult = _.get(this.props.reportData, "personReport.person[0]");
      let name = `${_.get(
        personResult,
        "names[0].name[0].firstName[0]._",
        ""
      )} ${_.get(
        personResult,
        "names[0].name[0].middleInitial[0]._",
        ""
      )} ${_.get(personResult, "names[0].name[0].lastName[0]._", "")}`;
      let nameNodes = _.get(personResult, "names[0].name");
      if (nameNodes !== undefined && nameNodes.length > 1) {
        nameNodes = _.orderBy(nameNodes, (e) => parseInt(e.$.weight, 10), [
          "asc",
        ]);
      }
      const internalNameID = _.get(
        this.props.additionalData,
        "internalNameID",
        "1"
      );
      _.forEach(nameNodes, (nameNode) => {
        if (nameNode.$.internalNameID === internalNameID) {
          name = `${_.get(nameNode, "firstName[0]._", "")} ${_.get(
            nameNode,
            "middleInitial[0]._",
            ""
          )} ${_.get(nameNode, "lastName[0]._", "")}`;
        }
        names.push(
          `${_.get(nameNode, "firstName[0]._", "")} ${_.get(
            nameNode,
            "middleInitial[0]._",
            ""
          )} ${_.get(nameNode, "lastName[0]._", "")}`
        );
      });

      const personData = PersonMetaData(personResult, this.props.userAccount);
      results.push(
        <Table.Row key={`Person_Name_Row`} className={"report-name-header"}>
          <Table.Cell colSpan={3} className={"icon-align-middle text-center"}>
            {name}
          </Table.Cell>
        </Table.Row>
      );
      if (this.props.isGoldReport === true || this.props.isSilverReport === true)
        personData.dod = getDodDate(get(personResult, "DODs[0].deceasedRecord[0].DOD[0]"), this.props);
      if (this.props.userAccount.btType !== "4") {
        results.push(
          <Table.Row
            key={`Person_Name_Sens`}
            className="report-section-header large-font"
          >
            <Table.Cell colSpan={3} className={"text-center"}>
              Sensitive Information
              {_.get(
                personResult,
                "SSNInfos[0].SSNInfo[0].SSNDeceased[0]._",
                ""
              ) === "Yes" ? (
                <span> Deceased</span>
              ) : null}
            </Table.Cell>
          </Table.Row>
        );
        results.push(
          <Table.Row key={`Person_Name_Ssn`}>
            <Table.Cell width={1} className={"border-right"}>
              <span className="text-bold medium-font">SSN: </span>
              {getSsn(personData.ssnTiered, this.props)}
            </Table.Cell>
            <Table.Cell className={"border-right"}>
              <span className="text-bold medium-font">ISSUED: </span>
              {personData.ssnYear}
              <span className="medium-font"> in </span>
              {personData.ssnLocation}
            </Table.Cell>
            <Table.Cell>
              <span className="text-bold medium-font">DOB: </span>
              {personData.dob}
              {personData.dod !== "" && personData.dod !== "N/A" ? (
                <span className="text-bold medium-font">
                  {" "}
                  DOD: {personData.dod}
                </span>
              ) : (
                <span className="text-bold medium-font">
                  {" "}
                  AGE: {personData.age}
                </span>
              )}
            </Table.Cell>
          </Table.Row>
        );
        results.push(<SSNRiskReport key={`SSN_Risk_Info`} {...this.props} />);
      }
    }
    return (
      <Accordion fluid styled>
        <Table stackable key={"Person_Header_Name"}>
          <Table.Body>
            <Table.Row>
              <Table.Cell width={4}>
                <div className={`no-print`}>
                  <Button
                    className={"margin-left-10"}
                    onClick={() => this.props.printContent("report", `Report`)}
                  >
                    Print
                  </Button>{" "}
                </div>
              </Table.Cell>
              <Table.Cell />
              <Table.Cell width={6} textAlign={`right`}>
                <div className={`no-print`}>
                  <CaseComponent
                    {...this.props}
                    actId={_.get(
                      this.props.reportData,
                      "personReport.log[0].actID[0]"
                    )}
                    compType={"result"}
                  />
                </div>
              </Table.Cell>
            </Table.Row>
            {results}
          </Table.Body>
        </Table>
        {names.length > 0 ? (
          <Table stackable key={"Person_Possible_Aliasses"}>
            <Table.Body>
              <Table.Row className="report-section-header">
                <Table.Cell className={"text-center"}>
                  Possible Aliases
                </Table.Cell>
              </Table.Row>
              <Table.Row>
                <Table.Cell>{_.join(names, ", ")}</Table.Cell>
              </Table.Row>
            </Table.Body>
          </Table>
        ) : null}

        <Table
          className={"table-no-border-and-padding"}
          stackable
          key={"Person_Row_Phone_Counties"}
        >
          <Table.Body>
            <Table.Row>
              <Table.Cell className="jumpnext-on-smallscreen">
                <Phone {...this.props} node={personResult} displayCarrier />
              </Table.Cell>
              <Table.Cell className="jumpnext-on-smallscreen">
                <Counties {...this.props} node={personResult} />
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Accordion>
    );
  }
}

export default PersonDetail;



// WEBPACK FOOTER //
// ./src/components/reports/PersonDetail.js